import { Pipe, PipeTransform } from "@angular/core";
import { TitleCasePipe } from "@angular/common";
import { Vehicle } from "src/app/core/services/myqq";

const { transform: titleCase } = new TitleCasePipe();
@Pipe({
  name: "displayVehicleDescription",
  standalone: false,
})
export class DisplayVehicleDescriptionPipe implements PipeTransform {
  transform(vehicle: Vehicle): string {
    if (!vehicle) {
      return "";
    }

    const fields = <["year", "color", "make", "model"]>[
      "year",
      "color",
      "make",
      "model",
    ];

    return titleCase(
      fields
        .map((field) => vehicle[field])
        .filter((field) => !!(field && field.trim()))
        .join(" ")
    );
  }
}
